import { API_DOMAIN } from 'constants/infograph';

type SaveCheckboxState = {
  infographId: string;
  pageId: string;
  widgetId: string;
  checkboxId: string;
  isChecked: boolean;
};

/**
 * Saves checkbox state to the database
 * Calls E2 public api endpoint /public/saveCheckboxState
 */
export const saveCheckboxState = ({ infographId, pageId, widgetId, checkboxId, isChecked }: SaveCheckboxState) => {
  return fetch(`${API_DOMAIN}/public/saveCheckboxState`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      infographId,
      pageId,
      widgetId,
      checkboxId,
      isChecked,
    }),
  });
};
